import React from 'react';
import { Col, Row } from 'antd';
import { SettingsGroupProps } from './SettingsGroupBox.types';
import { BlueTitle } from '../../../styles/common.styles';
import { SettingsContainer } from '../SettingsPage.styles';

const SettingsGroupBox: React.FC<SettingsGroupProps> = ({ title, children }) => (
    <SettingsContainer>
        <Row>
            <Col span={24}>
                <BlueTitle>{title}</BlueTitle>
            </Col>
        </Row>
        <Row>
            <Col span={24}>{children}</Col>
        </Row>
    </SettingsContainer>
);

export default SettingsGroupBox;
